require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/fn/regexp/escape.js
// module id = Rlym
// module chunks = 1